import { t } from "i18next";
import { getTranslatedMetadata } from "./Content";

export const AVAILABLE_METADATA_FILTERS = [
  "nationalities",
  "new_genres",
  "formats",
  "themes",
  "target_audiences",
  "duration_types",
  "keywords",
  "lang_availables",
  "production_date",
];

export const getMetadatas = ({
  metadatas,
  type,
  languageId,
  withTranslations = false,
}) => {
  // No metadata available yet ?
  if (!metadatas || !metadatas.isFetched) {
    return [];
  }

  // Special case for languages
  const metadatasArr =
    type === "languages" ? metadatas.data[type].data : metadatas.data[type];
  const objMetadatas = [];

  for (const index in metadatasArr) {
    const { translations, key } = metadatasArr[index];
    let label = key;
    const translationKey = "title";
    // Special case for nationalities, metadata names are differents
    if (type === "nationalities") {
      const { alpha2, alpha3 } = metadatasArr[index];
      label = alpha3 || alpha2;
    } else if (type === "duration_types") {
      const { duration } = metadatasArr[index];
      label = duration;
    }

    if (withTranslations) {
      label = t(`content:${type}.${label}`);
      // If we do have translations...
      if (translations && translations.length > 0) {
        label = getTranslatedMetadata(
          metadatasArr[index],
          translationKey,
          languageId,
        );
      }
    }

    objMetadatas.push({
      value: metadatasArr[index].uuid,
      label,
      data: metadatasArr[index],
    });
  }
  objMetadatas.sort((a, b) => (a.label < b.label ? -1 : 1));

  return objMetadatas;
};

export const getMetaValues = ({
  metadata,
  translationKey = "title",
  languageId,
}) => {
  if (!metadata?.length) {
    return null;
  }

  const objMetadatas = [];

  metadata.forEach((meta) => {
    objMetadatas.push({
      value: meta.uuid,
      label: meta.translations
        ? getTranslatedMetadata(meta, translationKey, languageId)
        : meta.key,
      data: meta,
    });
  });

  return objMetadatas;
};
